import type { GroovingType, GroovingTypeForSettings } from "./groovingTypes";

export const FASTENING_TYPE_CODE_VISIBLE_FASTENING = "visible-fastening";
export const FASTENING_TYPE_CODE_INVISIBLE_FASTENING = "invisible-fastening";

export const FASTENING_TYPE_CODES = [
  FASTENING_TYPE_CODE_VISIBLE_FASTENING,
  FASTENING_TYPE_CODE_INVISIBLE_FASTENING,
] as const;

export type KnownFasteningTypeCode = (typeof FASTENING_TYPE_CODES)[number];

export type FasteningType = {
  code: string;
  name: string;
  nameIt: string | null;
  nameDe: string | null;
  nameFr: string | null;
  nameEs: string | null;
  image: string | null;
  groovingTypes: GroovingType[];
};

// User side (settings, saved configuration): name already in the user's language.
export type FasteningTypeForSettings = Omit<
  FasteningType,
  "nameIt" | "nameDe" | "nameFr" | "nameEs" | "groovingTypes"
> & {
  groovingTypes: GroovingTypeForSettings[];
};

export type SearchFasteningTypesResponse = {
  items: FasteningType[];
  total: number;
};

// export type InsertFasteningTypeBody = {
//   name: string;
//   nameIt: string | null;
//   nameDe: string | null;
//   nameFr: string | null;
//   nameEs: string | null;
//   image?: string | null;
//   groovingTypes: GroovingType[];
// };

export type UpdateFasteningTypeBody = Omit<FasteningType, "code"> & {
  removeImage?: boolean;
};
